import { render } from "./TradePassportCertification.vue?vue&type=template&id=6fda5b66&scoped=true&ts=true"
import script from "./TradePassportCertification.vue?vue&type=script&lang=ts"
export * from "./TradePassportCertification.vue?vue&type=script&lang=ts"

import "./TradePassportCertification.vue?vue&type=style&index=0&id=6fda5b66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fda5b66"]])

export default __exports__